module.exports = __webpack_public_path__ + "img/teacher.39c1f7fd.png";